import React from "react";
import SectionShell from "../../components/sections/SectionShell";
import SocialOverview from "./SocialOverview";
import SocialQueue from "./SocialQueue";
import InstagramHub from "../InstagramHub";
import SocialTracker from "../SocialTracker";

// Social (Fedica-style): one hub for X and Instagram on official APIs only,
// plus the post tracker for platforms without an API. X Composer and the X Hub
// keep their own pages (they have their own ?tab= state), linked from here.
export const SOCIAL_TABS = [
  { id: "overview", label: "Overview", icon: "📊", render: () => <SocialOverview />,
    description: "Followers, the X queue and Instagram status at a glance." },
  { id: "queue", label: "X queue", icon: "🗓️", render: () => <SocialQueue />,
    description: "Drafts and scheduled X posts. Drafts are never posted until you schedule them." },
  { id: "instagram", label: "Instagram", icon: "📸", render: () => <InstagramHub />,
    description: "Connect with Instagram Login, approve and publish posts, and see insights through the official Instagram API." },
  { id: "tracker", label: "Post tracker", icon: "🗂️", render: () => <SocialTracker />,
    description: "Ledger of posts across every platform, including the ones without an API." },
  { id: "compose", label: "X Composer", icon: "✍️", href: "/crm/x" },
  { id: "x-hub", label: "X Hub", icon: "𝕏", href: "/crm/platform-hubs/x" },
];

export const SOCIAL_TAB_ALIASES = {
  "multi-tracker": "tracker", posts: "tracker", ledger: "tracker",
  ig: "instagram", x: "queue", drafts: "queue", schedule: "queue",
};

export default function SocialSection() {
  return (
    <SectionShell
      sectionId="social"
      title="Social"
      overline="X · INSTAGRAM · POST TRACKER · OFFICIAL APIs ONLY"
      tabs={SOCIAL_TABS}
      aliases={SOCIAL_TAB_ALIASES}
    />
  );
}
